import styled from "styled-components"
import {useNavigate} from "react-router-dom"
import {Button} from "antd"
import Icon from "../../components/Icon/Icon"
/*import {faChevronDown} from "@fortawesome/pro-regular-svg-icons/faChevronDown"*/
import {UserOutlined} from "@ant-design/icons"
import {useState} from "react"
import {faBars} from "@fortawesome/pro-light-svg-icons"

const menu = [
	{key: 'routing', title: 'Маршрутизация'},
	{key: 'monitoring', title: 'Мониторинг'},
	{key: 'mobile-app', title: 'Мобильное приложение'},
	{key: 'services', title: 'Сервисы', children: true},
	{key: 'price', title: 'Тарифы'},
	{key: 'contacts', title: 'Контакты'}
]

const services = [
	/*{key: 'reports', title: 'Отчёты', description: 'Система адресной доставки отчётов'},*/
	{key: 'motivation', title: 'Мотивация водителей', description: 'Бонусная система и заработная плата водителей'},
	{key: 'fines', title: 'Штрафы ГИБДД', description: 'Проверка штрафов с привязкой к водителю'},
	{key: 'telegram', title: 'Телеграм бот', description: 'Оповещение сотрудников о важных событиях'},
	{key: 'temperature', title: 'Контроль температуры', description: 'Инструменты для контроля температурного режима'},
	{
		key: 'observers',
		title: 'Кабинет клиента',
		description: 'Позвольте вашим партнёрам и клиентам мониторить доставку'
	},
	{key: 'director', title: 'Руководителю', description: 'Доступ к опертивной информации в смартфоне'}
]

const Header = () => {

	const navigate = useNavigate()
	const [open, setOpen] = useState(false)

	return (
		<>
			<Fixed>
				<Container>
					<Logo onClick={() => {
						setOpen(false)
						navigate(('/'))
					}}>
						<img src="/assets/img/svg/logo.svg"/>
					</Logo>
					<Menu>
						{menu.map((item, index) => (
							<MenuItem key={'m' + index} onClick={() => navigate('/' + item.key)}>
								{item.title}
							</MenuItem>
						))}
					</Menu>
					<Buttons>
						<a href="https://app.ats24.ru" target="_blank">
							<Button className="account-button" color="default" variant="solid" icon={<UserOutlined/>}>
								Аккаунт
							</Button>
						</a>
						<AdaptiveMenuIcon className="adaptive-menu-button" onClick={() => setOpen(open => !open)}>
							<Icon name={faBars} size={36}/>
						</AdaptiveMenuIcon>
					</Buttons>
				</Container>
				<AdaptiveMenu open={open}>
					{menu.map((item, index) => (
						<AdaptiveMenuItem key={'m' + index} onClick={() => {
							setOpen(false)
							navigate('/' + item.key)
						}}>
							{item.title}
						</AdaptiveMenuItem>
					))}
				</AdaptiveMenu>
			</Fixed>

			<Overlay onClick={() => {
				setOpen(false)
			}} className={`top-submenu-overlay ${open ? 'open' : ''}`}/>
		</>
	)
}

export default Header

const Fixed = styled.div`
    display: flex;
    flex: 1;
    position: sticky;
    flex-direction: column;
    align-items: center;
    z-index: 10;
    top: 0;
    background-color: #FFFFFF;
    border-bottom: solid 1px #EEEEEE;
`
const Container = styled.div`
    display: flex;
    width: 100%;
    max-width: calc(1320px + 3rem);
    padding: 0.83rem 1.5rem;
    box-sizing: border-box;
    align-items: center;
    gap: 1.11rem;
    @media (max-width: 920px) {
        padding: 0.5rem 0.75rem;
        max-width: calc(1320px + 1.5rem);
    }
`
const Logo = styled.div`
    display: flex;
    cursor: pointer;
`
const Menu = styled.div`
    display: flex;
    flex: 1;
    gap: 2rem;
    @media (max-width: 1160px) {
        display: none;
    }
`
const MenuItem = styled.div`
    display: flex;
    align-items: center;
    gap: 0.3rem;
    cursor: pointer;
`
const Buttons = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    @media (max-width: 1160px) {
        flex: 1;
        .account-button {
            display: none;
        }

        .adaptive-menu-button {
            display: flex;
        }
    }
`
const AdaptiveMenu = styled.div`
    display: ${props => props.open ? '' : 'none'};
    width: 100%;
    max-width: calc(1320px + 3rem);
    padding: 0.83rem 1.5rem;
    box-sizing: border-box;
    align-items: center;
    gap: 1.11rem;
    @media (max-width: 920px) {
        padding: 2rem 0.75rem;
        max-width: calc(1320px + 1.5rem);
    }
    /*flex: 1;
    flex-direction: column;
    padding: 2rem 1.5rem 0 1.5rem;
    @media (max-width: 920px) {
        width: 100%;
        padding: 2rem 0.75rem 0 0.75rem;
    }
    cursor: pointer;*/
`
const AdaptiveMenuItem = styled.div`
    display: flex;
    border-top: solid 1px #000000;
    padding: 1rem 0;
    font-size: 1.6rem;
`
const AdaptiveMenuIcon = styled.div`
    display: none;
    align-items: center;
    cursor: pointer;
`
const Overlay = styled.div`
    position: fixed;
    inset: 70px 0 0 0;
    background-color: rgba(0, 0, 0, .55);
    z-index: 9;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s ease-in-out, visibility 0s 0.3s;
`